import { NavLink, useParams } from "react-router-dom";
import { Menu } from "semantic-ui-react";

interface Props {
  iconOnly: boolean;
}

const RegisterSideMenu = ({ iconOnly }: Props) => {
  const { orgName } = useParams<{ orgName: string }>();
  const { projectName } = useParams<{ projectName: string }>();
  const { registerTitle } = useParams<{ registerTitle: string }>();

  return (
    <Menu icon={iconOnly ? true : "labeled"} color="black" borderless secondary vertical style={{ marginRight: "1px" }}>
      <Menu.Item
        icon="chart bar outline"
        as={NavLink}
        content={!iconOnly && "Dashboard"}
        to={`/${orgName}/projects/${projectName}/registers/${registerTitle}/dashboard`}
      />
      <Menu.Item
        icon="clipboard outline"
        as={NavLink}
        content={!iconOnly && "Permits"}
        to={`/${orgName}/projects/${projectName}/registers/${registerTitle}/permits`}
      />
      <Menu.Item
        icon="folder open outline"
        as={NavLink}
        content={!iconOnly && "Documents"}
        to={`/${orgName}/projects/${projectName}/registers/${registerTitle}/documents`}
      />
      {/* <Menu.Item
        icon="setting"
        as={NavLink}
        content={!iconOnly && "Settings"}
        to={`/${orgName}/projects/${projectName}/settings`}
      /> */}
    </Menu>
  );
};

export default RegisterSideMenu;
